import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import BrandAiChat from "./components/feature/BrandAiChat";
import ScrollToTop from "./components/base/ScrollToTop";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import SiteLocaleTranslator from "./components/feature/SiteLocaleTranslator";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteLocaleTranslator />
        <ScrollToTop />
        <AppRoutes />
        <BrandAiChat brandName="機曜文化" siteUrl="https://giyao.sonbook.net" />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
